import type { ReactElement, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { Spinner } from '../components'
import { LOGIN_PATH } from '../lib/routes'
import { useSession } from './useSession'

export type RequireAuthProps = {
  children: ReactNode
}

/**
 * The guard around the whole authenticated area.
 *
 *   - While the first `auth.me` is in flight, a quiet loading state — never a
 *     redirect. The silent refresh can add a round-trip, and bouncing here would
 *     flash the login form on every reload of a valid session.
 *   - Once settled and unauthenticated (expired session, refresh failed), a
 *     clean /login rather than letting every query on the screen show an error.
 */
export const RequireAuth = ({ children }: RequireAuthProps): ReactElement => {
  const { isAuthenticated, isLoading } = useSession()

  if (isLoading) {
    return <Spinner size="page" label="Cargando tu sesión…" />
  }

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_PATH} replace />
  }

  return <>{children}</>
}
